import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { CarruselComponent } from './components/shared/carrusel/carrusel.component';
import { ServiciosLiteComponent } from './components/shared/servicios-lite/servicios-lite.component';
import { ContactanosLiteComponent } from './components/shared/contactanos-lite/contactanos-lite.component';
import { NosotrosComponent } from './components/nosotros/nosotros.component';
import { HomeComponent } from './components/home/home.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { ServiviciosService } from './components/services/servicios.service';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { ServicioComponent } from './components/servicio/servicio.component';
import { ProductosComponent } from './components/productos/productos.component';
import { ProductoComponent } from './components/producto/producto.component';
import { ProductosService } from './components/services/productos.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    CarruselComponent,
    ServiciosLiteComponent,
    ContactanosLiteComponent,
    NosotrosComponent,
    HomeComponent,
    ContactoComponent,
    FooterComponent,
    ServiciosComponent,
    ServicioComponent,
    ProductosComponent,
    ProductoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [ ServiviciosService,ProductosService ],
  bootstrap: [AppComponent]
})
export class AppModule { }
